import React, { useState, useEffect } from "react";
import history from "../history";
import LoginForm from "../components/LoginForm";
import StepMessage from "../components/Messages/StepMessage";
import { Container, Row, Col, Button, Alert } from "react-bootstrap";
import AuthService from "../services/AuthService";
import { DASHBOARDURL, awaitableRootSchoolCode } from "../apis/ApiConfig";
import { getSchoolDataForLogin } from "../actions/SchoolActions";
import { connect } from "react-redux";
import { studentLoginPageAuthReset } from "../actions/AuthActions"


export const StudentLoginPage = ({ match, studentLoginPageAuthReset, getSchoolDataForLogin, schoolCode }) => {
  const [notifications, setNotifications] = useState(null);
  const [domain, setDomain] = useState(match?.params?.domain);

  useEffect(() => {
    studentLoginPageAuthReset();
  }, [studentLoginPageAuthReset]);

  useEffect(() => {
    async function SearchNotifications() {
      let localDate = new Date();

      let Notification = {
        DisplayLocation: "LOGIN",
        DisplayToType: "STUDENTSANDPARENTS",
        StartDateTime: localDate,
        EndDateTime: localDate,
      };

      Notification.SchoolCode = schoolCode;
      Notification.NotificationLevel = "BOTH";

      let notifications = await AuthService.SearchNotification(Notification);
      setNotifications(notifications);
    };

    SearchNotifications();
  }, [schoolCode]);

  useEffect(() => {
    async function fetchData() {
      let schoolCode = await awaitableRootSchoolCode();
      getSchoolDataForLogin(
        schoolCode
      );
    }

    if (domain !== match?.params?.domain) {
      setDomain(match?.params?.domain)
      fetchData();
    }
  }, [domain, match?.params?.domain, getSchoolDataForLogin]);

  useEffect(() => {
    AuthService.getBetaTestToggleConfig("toggle.keycloak").then(x => {
      if (x === true) {
        window.location.replace(DASHBOARDURL);
      } 
    });
  }, [])


  function removeNotification(key) {
    let filteredNotifications = notifications?.filter((x) => x.id !== key);
    setNotifications(filteredNotifications);
  };

  function renderNotifications() {
    if (notifications) {
      return notifications.map((notification) => {
        return (
          <Alert
            key={notification.id}
            dismissible
            variant={
              notification.messageTypeReadableString === "Information"
                ? "info"
                : notification.messageTypeReadableString.toLowerCase()
            }
            onClick={() => removeNotification(notification.id)}
          >
            <h6 className="inline">{notification.message}</h6>
          </Alert>
        );
      });
    }
    return null;
  };


  return (
    <>
      {renderNotifications()}
      <Container className="centered">
        <Row className="pullLeft">
          <Col sm={8}>
            <Row>
              <Col className="mt-5" style={{ minWidth: "250px" }}>
                <LoginForm domain={domain} />
              </Col>
              <Col className="mt-5" style={{ minWidth: "200px" }}>
                <i className="far fa-user-circle fa-4x" />
                <h4>Create Account</h4>
                <Button
                  type="button"
                  variant="success"
                  onClick={() =>
                    domain
                      ? history.push(`/studentLookup/${domain}`)
                      : history.push("/studentLookup")
                  }
                >
                  Sign Up
                </Button>
              </Col>
            </Row>
          </Col>
          <Col sm={4} className="mt-5 mb-3">
            <StepMessage stepNumber="1" stepText="Create Account">
              If you have been selected for verification for multiple aid
              years, you can use{" "}
              <strong>
                <u>User login</u> to access your existing account.
              </strong>
              <br />
              <br />
              If the student is listed as a dependent on the FAFSA,{" "}
              <strong>
                both the student and parents/guardians are required to create
                an account;
              </strong>{" "}
              if listed as independent, only the student will be required to
              create an account.
            </StepMessage>
            <StepMessage stepNumber="2" stepText="Complete Tasks">
              The Task List contains links to all the information necessary to
              fulfill verification. <br />
              <br />
              You will need:
              <ul style={{ paddingLeft: "1.8em" }}>
                <li>Student income statements</li>
                <li>Parent/Guardian income</li>
                <li>Copy of other documentation</li>
              </ul>
            </StepMessage>
            <StepMessage stepNumber="3" stepText="Sign and Submit">
              Your verification process will not be completed until you sign
              and submit the binder. <br /> <br />
              Make sure you complete this final step when prompted after
              completing your task list
            </StepMessage>
          </Col>
        </Row>
      </Container>
    </>
  );
}

const mapStateToProps = state => {
  return {
    schoolCode: state.school.schoolCode
  };
};

export default connect(mapStateToProps, { studentLoginPageAuthReset, getSchoolDataForLogin })(
  StudentLoginPage
);
